function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
$(document).ready(function() {

    /* ==========================================================================
            Chaging Selects for Radio Buttons on Product Pages
        ========================================================================== */
      if (
        $(".single-option-selector").length &&
        window.location.href.indexOf("t-shirt-club") === -1
      ) {
        var $selectElem = $(".single-option-selector"),
          $radioContainer = $("#radio-options-wrapper"),
          radioOptionsItemHtml = "";

        // iterating over the select elements
        $selectElem.each(function(index) {
          var $self = $(this),
            selectTitle = $(this)
              .prev("label")
              .text()
              .trim(),
            elemNumber = index;

          radioOptionsItemHtml += "<div class='radio-options-item'>";
          radioOptionsItemHtml +=
            "<span class='radio-item-title'>" + selectTitle + "</span>";
          // iterating over the option elements
          $self.children("option").each(function(index, elem) {
    //         var isChecked = elem.selected ? "checked" : "",
              var isChecked = "",
              radioId = elemNumber + "-" + index;

            radioOptionsItemHtml +=
              "<input type='radio' id='size-" +
              radioId +
              "' name='radio-size-" +
              elemNumber +
              "' value='" +
              elem.value +
              "' data-elem-index='" +
              elemNumber +
              "' data-option-index='" +
              index +
              "'" +
              isChecked +
              "><label for='size-" +
              radioId +
              "' style='cursor:pointer'>" +
              elem.value +
              "</label>";
          });

          radioOptionsItemHtml += "</div>";
        });
        // adding the html to the $radioContainer
        $radioContainer.html(radioOptionsItemHtml).addClass("active");

        // when clicking, it will trigger a change on the hidden select tag
        $("body").on(
          "click tap touchend",
          "#radio-options-wrapper label",
          function() {
            var currentValue = $(this)
                .prev()
                .val(),
              currentIndex = $(this)
                .prev()
                .data("elem-index"),
              optionIndex = $(this)
                .prev()
                .data("option-index");

            // change size on fbt to match what they selected
            $(".cbb-recommendations-variant-select").each(function() {
              $(this).val(optionIndex);
            });

            $("#productSelect-option-" + currentIndex)
              .val(currentValue)
              .trigger("change");
          }
        );
      }


      //This function checks to make sure all varients have at least one option checkd
      //before allowing user to add to cart. 
  $('#AddToCart').on('click tap', function(e) {

    //This sets our variables for this function.
    //minOptions means that all of the variants have at least one option selected
    //tot_children is the total amount of varients
    var minOptions = new Boolean(false);
    var tot_children = $("#radio-options-wrapper").children().length;
    var checker = 0;
    var def = document.getElementById("size-0-0").value;

    //No varients assumes "Default Title" for underlying varient container
    if (def == "Default Title") {
      minOptions = true;
      checker = tot_children;
    }

   	//This checks to make sure that when there are varients,
    //at least one for each type has been selected
    $('.radio-options-item input').each(function() {
        if(($(this).is(':checked')) == true) {
            minOptions = true;
            checker = checker +1;
        }
    });


    //Error checking to stop adding to cart in some cases
    if (minOptions == false)  {
      e.preventDefault();
      $('.options-error').css("display", "block");
      window.setTimeout(function() {
        $(".options-error").fadeOut("fast");
      }, 5000);
    } else if (minOptions == true && checker != tot_children) {
      e.preventDefault();
      $('.options-error').css("display", "block");
      window.setTimeout(function() {
        $(".options-error").fadeOut("fast");
      }, 5000);
    } else if (minOptions == true){
      $('.options-error').css("display", "none");
    }



  });








  /*============================================================================
    Quantity Product Box on Mobile
    ==============================================================================*/
  (function(i) {
    var e = /iPhone/i,
      n = /iPod/i,
      o = /iPad/i,
      t = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
      r = /Android/i,
      d = /BlackBerry/i,
      s = /Opera Mini/i,
      a = /IEMobile/i,
      b = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
      h = RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i"),
      c = function(i, e) {
        return i.test(e);
      },
      l = function(i) {
        var l = i || navigator.userAgent;
        (this.apple = {
          phone: c(e, l),
          ipod: c(n, l),
          tablet: c(o, l),
          device: c(e, l) || c(n, l) || c(o, l)
        }),
          (this.android = {
            phone: c(t, l),
            tablet: !c(t, l) && c(r, l),
            device: c(t, l) || c(r, l)
          }),
          (this.other = {
            blackberry: c(d, l),
            opera: c(s, l),
            windows: c(a, l),
            firefox: c(b, l),
            device: c(d, l) || c(s, l) || c(a, l) || c(b, l)
          }),
          (this.seven_inch = c(h, l)),
          (this.any =
            this.apple.device ||
            this.android.device ||
            this.other.device ||
            this.seven_inch);
      },
      v = (i.isMobile = new l());
    v.Class = l;
  })(window);

  if (
    isMobile.android.phone ||
    isMobile.apple.phone ||
    isMobile.apple.ipod ||
    isMobile.other.opera ||
    isMobile.other.firefox ||
    isMobile.other.blackberry
  ) {
    //inside the mobile function
    $(".template-product .quantity-selector")
      .css("padding-top", "8px")
      .css("padding-bottom", "5px")
      .css("padding-left", "11px")
      .css("padding-right", "11px");
  }

  /*============================================================================
    See More Tags
    ==============================================================================*/
  $(".collection-see-more-tags").on("click tap", function() {
    $(this).hide();
    $(".collection-tag-sidebar")
      .css("height", "100%")
      .css("max-height", "100%");
  });

  /*============================================================================
    Product Page Tabs for Descriptions and Reviews
    ==============================================================================*/
  $("ul.tabs li").click(function() {
    var tab_id = $(this).attr("data-tab");

    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  /*============================================================================
     Nav fade in
    ==============================================================================*/
  window.setTimeout(function() {
    $(".template-index .nav-bar").css("opacity", "1");
  }, 100);

  /*============================================================================
    Hover Effect on 'From The Blog'
    ==============================================================================*/
  $(".blog-link-a").each(function() {
    $(this).hover(function() {
      $(this)
        .next()
        .toggleClass("hover-effect");
    });
  });

  /*============================================================================
    Hero Slick Carousel
    ==============================================================================*/
  $("#Hero").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    nextArrow: "#slideshow .arrows-container .right",
    prevArrow: "#slideshow .arrows-container .left",
    adaptiveHeight: true
  });

  /*============================================================================
    Testimonials Slick Carousel
    ==============================================================================*/
  $("#testimonial-hero").slick({
    dots: false,
    infinite: true,
    slidesToShow: 3,
    nextArrow: "#testimonials .arrows-container .right",
    prevArrow: "#testimonials .arrows-container .left"
  });

  /*============================================================================
    Home Page Collection Slick Carousel
    ==============================================================================*/
  // $('#collection-grid').slick({
  //     dots: false,
  //     infinite: true,
  //     slidesToShow: 4,
  //     autoplay: true,
  //     autoplaySpeed: 4000,
  //     nextArrow: '#shopify-section-1513811742073 .arrows-container .right',
  //     prevArrow: '#shopify-section-1513811742073 .arrows-container .left',
  //     responsive: [
  //     {
  //        breakpoint: 1100,
  //        settings: {
  //            slidesToShow: 4,
  //        }
  //     },
  //     {
  //        breakpoint: 1090,
  //        settings: {
  //            slidesToShow: 3,
  //        }
  //     },
  //     {
  //        breakpoint: 900,
  //        settings: {
  //            slidesToShow: 2,
  //        }
  //     },
  //    {
  //        breakpoint: 640,
  //        settings: {
  //            slidesToShow: 1,
  //        }
  //    }
  //  ]
  // });

  /*============================================================================
    Related Products Carousel
    ==============================================================================*/
  $(".related-products-carousel-container .container").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    nextArrow: ".fa-caret-right",
    prevArrow: ".fa-caret-left",
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  /*============================================================================
    Product carousel on mobile
    ==============================================================================*/
  $(".mobile-carousel").slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
    customPaging: function(slider, i) {
      return '<div class="pager__item" id=' + i + ">  </div>";
    },
    useTransform: true,
    cssEase: "ease-in-out",
    nextArrow: ".fa-caret-right",
    prevArrow: ".fa-caret-left"
  });

  /* ==========================================================================
    #Changing Selects for Radio Buttons for mobile
    ========================================================================== */
  if ($(window).width() < 1023) {
    if ($(".single-option-selector").length) {
      var $selectElem = $(".single-option-selector"),
        $radioContainer = $("#radio-options-wrapper"),
        radioOptionsItemHtml = "";

      // iterating over the select elements

      $selectElem.each(function(index) {
        var $self = $(this),
          selectTitle = $(this)
            .prev("label")
            .text()
            .trim(),
          elemNumber = index;

        radioOptionsItemHtml += "<div class='radio-options-item'>";
        radioOptionsItemHtml +=
          "<span class='radio-item-title'>" +
          selectTitle +
          "</span><div class='custom-variant-options'>";
        // iterating over the option elements
        $self.children("option").each(function(index, elem) {
          var isChecked = elem.selected ? "checked" : "",
            radioId = elemNumber + "-" + index;

          radioOptionsItemHtml +=
            "<input type='radio' id='option-" +
            radioId +
            "' name='radio-option-" +
            elemNumber +
            "' value='" +
            elem.value +
            "' data-elem-index='" +
            elemNumber +
            "'" +
            isChecked +
            "><label for='option-" +
            radioId +
            "' style='cursor:pointer'>" +
            elem.value +
            "</label>";
        });

        radioOptionsItemHtml += "</div></div>";
      });

      // adding the html to the $radioContainer
      $radioContainer.html(radioOptionsItemHtml).addClass("active");

      // if the first variant is 'default title', hide it and do not show it
      if ($('label[for="option-0-0"]').text() == "Default Title") {
        $('label[for="option-0-0"]').hide();
      }

      // when clicking, it will trigger a change on the hidden select tag
      $("body").on(
        "click tap touchend",
        "#radio-options-wrapper label",
        function() {
          var currentValue = $(this)
              .prev()
              .val(),
            currentIndex = $(this)
              .prev()
              .data("elem-index");

          $("#productSelect-option-" + currentIndex)
            .val(currentValue)
            .trigger("change");
        }
      );
    }
  }
});
